import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import "../../../styles/pages-styles/main-dashboard-pages-styles/knowledge-pages-styles/KnowledgeCatergory.css";



// Box component that can be reused with different sizes and colors
const AssessmentBox = ({ color, onClick, size = "small" }) => {
  const getColorClass = () => {
    if (color === "red") return "box-red";
    if (color === "green") return "box-green";
    if (color === "yellow") return "box-yellow";
    return "box-empty";
  };
  
  const getSizeClass = () => {
    if (size === "large") return "box-large";
    if (size === "medium") return "box-medium";
    return "box-small";
  };
  
  return (
    <div 
      className={`assessment-box ${getColorClass()} ${getSizeClass()}`}
      onClick={onClick}
    />
  );
};

// Modal component for box clicks
const AssessmentModal = ({ show, onHide, title, content }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>{title}</h4>
        <p>{content}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

// Section component for each specialty
const AssessmentSection = ({ title, boxes }) => {
  const [modalShow, setModalShow] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", content: "" });
  
  const handleBoxClick = (index) => {
    setModalContent({
      title: `${title} - Box ${index + 1}`,
      content: `Details for ${title} assessment item ${index + 1}`
    });
    setModalShow(true);
  };
  
  return (
    <div className="assessment-section">
      <h2 className="section-title">{title}</h2>
      <div className="section-content">
        <div className="boxes-container">
          {boxes.map((box, index) => (
            <AssessmentBox 
              key={index}
              color={box.color}
              size={box.size}
              onClick={() => handleBoxClick(index)}
            />
          ))}
        </div>
      </div>
      
      <AssessmentModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={modalContent.title}
        content={modalContent.content}
      />
    </div>
  );
};

// Sidebar component
const Sidebar = () => {
  return (
    <div className="sidebar">
      <h2 className="sidebar-title">Key</h2>
      
      <div className="sidebar-section">
        <h3>Size</h3>
        <div className="sidebar-item">
          <div className="checkbox"></div>
          <span>A++</span>
        </div>
        <div className="sidebar-item">
          <div className="checkbox"></div>
          <span>A+</span>
        </div>
        <div className="sidebar-item">
          <div className="checkbox small"></div>
          <span>A</span>
        </div>
      </div>
      
      <div className="sidebar-section">
        <h3>Colour</h3>
        <div className="sidebar-item">
          <div className="color-box green"></div>
          <span>Acceptable recall</span>
        </div>
        <div className="sidebar-item">
          <div className="color-box yellow"></div>
          <span>Unacceptable recall ({'>'}=50%)</span>
        </div>
        <div className="sidebar-item">
          <div className="color-box red"></div>
          <span>Unacceptable recall (&lt;50%)</span>
        </div>
        <div className="sidebar-item">
          <div className="color-box empty"></div>
          <span>Not attempted</span>
        </div>
      </div>
    </div>
  );
};

// Main App component
const KnowledgeCatergory = () => {
  // Sample data for the sections
  const sections = [
    {
      title: "Administration and health informatics",
      boxes: Array(20)
        .fill({})
        .map((_, i) => ({
          color: i === 13 ? "red" : "",
          size: "large",
        })),
    },
    {
      title: "Dermatology",
      boxes: Array(30)
        .fill({})
        .map((_, i) => ({
          color: i === 1 ? "green" : i === 9 ? "red" : i === 17 ? "red" : "",
          size: "small",
        })),
    },
    {
      title: "Ear, nose and throat",
      boxes: Array(10)
        .fill({})
        .map((_, i) => ({
          color: i === 4 ? "red" : "",
          size: "small",
        })),
    },
    {
      title: "Evidence based clinical practice",
      boxes: Array(50)
        .fill({})
        .map((_, i) => ({
          color: i === 46 ? "green" : "",
          size: "small",
        })),
    },
  ];

  return (
    <div className="medical-assessment-container">
      <Sidebar />
      <div className="assessment-content">
        {sections.map((section, index) => (
          <AssessmentSection
            key={index}
            title={section.title}
            boxes={section.boxes}
          />
        ))}
      </div>
    </div>
  );
};

export default KnowledgeCatergory;